import { styled } from 'styled-components';

import { colors, cssBreakpoints, gutterWidth, maxWidth } from '#/theme/theme';

export const ViewOrgPageLayoutHeader = styled.header`
  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    margin-bottom: 16px;
    margin-top: 32px;
  }
`;

export const ViewOrgPageFooterHolder = styled.div`
  background: ${colors.backgroundGrey};
  margin-top: 70px;
  padding: 70px 0;
  text-align: center;
`;

export const ViewOrgPageFooterWrapper = styled.div`
  margin: 0 auto;
  max-width: ${maxWidth[3]}px;
  padding: 0 ${gutterWidth / 2}px;
`;

export const ViewOrgPageLayoutSidebarTitle = styled.div`
  /* block-no-empty */
`;

export const ViewOrgPageHeaderSocialLinks = styled.div`
  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: none;
  }
`;

export const ViewOrg_Box_1 = styled.div`
  margin-bottom: 12px;
  line-height: 1;
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    margin-bottom: 24px;
  }
`;

export const ViewOrg_Box_3 = styled.div`
  height: 35px;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    height: 200px;
  }

  &[data-is-owner] {
    height: 80px;

    @media all and (min-width: ${cssBreakpoints.mdUp}) {
      height: 200px;
    }
  }
`;

export const ViewOrg_Hide_1 = styled.div`
  display: none;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: block;
  }
`;

export const ViewOrg_Hide_2 = styled.div`
  display: none;

  @media all and (min-width: ${cssBreakpoints.xsUp}) {
    display: block;
  }
`;

export const ViewOrg_Hide_3 = styled.div`
  display: block;

  @media all and (min-width: ${cssBreakpoints.xsUp}) {
    display: none;
  }
`;
